import * as yup from "yup";
import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import {Alert, Card, CardBody, Col, Container, Form, FormGroup, Nav, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import withReducer from "../../../../store/withReducer";
import productReducer from "../../store";
import PreLoader from "../../../../share-components/ui/preLoader";
import WhyYouLoveItForm from "./whyYouLoveItForm";
import {
    addWhyYouLoveIt,
    closeEditDialog,
    deleteWhyYouLoveIt,
    getAllWhyYouLoveIt,
    openEditDialog,
    openNewDialog,
    selectWhyYouLoveIt,
    updateWhyYouLoveIt
} from "../../store/whyYouLoveItSlice";

const dataMenu = [
    {
        type: 0,
        text: 'Products',
        link: '/product'
    },
    {
        type: 1,
        text: 'Product Setting',
        link: ''
    },
    {
        type: 1,
        text: "Why You'll Love It",
        link: ''
    }
];

const defaultValues = {
    id: '',
    title: '',
    icon: null,
    icon_url: '',
};

const schema = yup.object().shape({
    title: yup.string().required('You must enter a title'),
    icon: yup.mixed().when('id', {
        is: (id) => !id,
        then: (schema) => schema.required('An icon is required'),
    }),
});

const WhyYouLoveIt = () => {
    const dispatch = useDispatch();
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const whyYouLoveIt = useSelector(selectWhyYouLoveIt);
    const [buttonDisable, setButtonDisable] = useState(false);

    useEffect(() => {
        dispatch(getAllWhyYouLoveIt({title})).then(res => {
            if (!res.error) {
                setError('');
            } else {
                setError("Unable to load Why You'll Love It items. Please try again.");
            }
            setLoading(false);
        });
    }, [dispatch, title]);

    const tableColumns = [
        {
            name: 'Icon',
            selector: row => row.icon_url,
            sortable: false,
            left: true,
            cell: (row) => (
                row.icon_url
                    ? <img src={row.icon_url} alt="" style={{width: 36, height: 36, objectFit: 'contain'}}/>
                    : <span className="text-muted">&mdash;</span>
            ),
        },
        {
            name: 'Title',
            selector: row => row.title,
            sortable: true,
            left: true,
        },
    ];

    const {handleSubmit, formState, reset, register, setValue, trigger, getValues} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const {errors} = formState;

    const onSubmitForm = (dialog, data) => {
        setButtonDisable(true);
        if (dialog.type === 'new') {
            dispatch(addWhyYouLoveIt({...data})).then(res => {
                setButtonDisable(false);
                if (!res.error) closeDialog(dialog.type)
            });
        } else {
            dispatch(updateWhyYouLoveIt({...data})).then(res => {
                setButtonDisable(false);
                if (!res.error) closeDialog(dialog.type);
            });
        }
    }

    const onEdit = (row) => {
        dispatch(openEditDialog(row));
    }

    const onDelete = (row) => {
        dispatch(deleteWhyYouLoveIt(row.id))
    }

    const closeDialog = () => {
        dispatch(closeEditDialog());
    }

    return (
        <Fragment>
            <Container fluid={true} className="product-wrapper">
                {loading ? <><PreLoader></PreLoader></> : <>
                    <Breadcrumb data={dataMenu} title="Why You'll Love It"/>
                    <div className="product-grid">
                        <div className="feature-products">
                            <Row>
                                <Col sm="12">
                                    <Card>
                                        <Row>
                                            <Col sm="6">
                                                <Nav tabs className="border-tab"></Nav>
                                            </Col>
                                            <Col sm="6">
                                                <div className='float-sm-right p-3'>
                                                    <a className="btn btn-sm btn-primary"
                                                       onClick={() => {
                                                           dispatch(openNewDialog())
                                                       }}
                                                    > <i className="fa fa-plus"></i> Add Item</a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl="12" sm="12">
                                    <Form>
                                        <FormGroup>
                                            <input onChange={(e) => setTitle(e.target.value)} name="title"
                                                   type="text" className="form-control"
                                                   placeholder="Search By Title"/>
                                        </FormGroup>
                                    </Form>
                                </Col>
                            </Row>
                            {error && (
                                <Row>
                                    <Col sm="12">
                                        <Alert color="danger">{error}</Alert>
                                    </Col>
                                </Row>
                            )}
                            <Row>
                                <Col sm="12">
                                    <Card>
                                        <CardBody>
                                            <div className="table-responsive product-table mt-4">
                                                <CommonDataTable
                                                    headerColumns={tableColumns}
                                                    gridData={whyYouLoveIt}
                                                    pagination
                                                    onEdit={onEdit}
                                                    onDelete={onDelete}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </>}
            </Container>
            <ModalFormSubmit
                defaultValues={defaultValues}
                schema={schema}
                onSubmitForm={onSubmitForm}
                reset={reset}
                formState={formState}
                handleSubmit={handleSubmit}
                title="Why You'll Love It"
                selector='product'
                dialog={({product}) => product.whyYouLoveIt.addDialog}
                closeDialog={closeDialog}
                setValue={setValue}
                getValues={getValues}
                buttonDisable={buttonDisable}
            >
                <WhyYouLoveItForm
                    errors={errors} register={register} setValue={setValue}
                    trigger={trigger} getValues={getValues}
                />
            </ModalFormSubmit>
        </Fragment>
    );
}

export default withReducer([{product: productReducer}])(WhyYouLoveIt)
